export const SOCKET_EVENTS = {
  CONNECTION_ERROR: 'connect_error',

  ROOM_JOIN: 'room:join',
  ROOM_JOINED: 'room:joined',
  ROOM_LEAVE: 'room:leave',
  ROOM_LEFT: 'room:left',
  ROOM_ERROR: 'room:error',

  CART_UPDATED: 'cart:updated',
  ORDER_UPDATED: 'order:updated',
  ORDER_CREATED: 'order:created',
  PRODUCT_UPDATED: 'catalog:updated',
  DRIVER_NOT_FOUND_UPDATED: 'driver-not-found:updated',
  DRIVER_NOT_FOUND_DELETED: 'driver-not-found:deleted',
  RETURN_UPCS_UPDATED: 'return-upcs:updated',
  RETURN_UPCS_DELETED: 'return-upcs:deleted',
  RECEIPT_CAPTURE_DELETED: 'receipt:capture:deleted',

  /** Shopper marked an item missing — customer should review order context. */
  ORDER_MISSING_ITEM: 'order:missing_item',
  /** Customer input needed (substitute or extra-store approval). */
  ORDER_DECISION_REQUIRED: 'order:decision_required',
  /** Decision recorded (customer choice or timeout default). */
  ORDER_DECISION_RESOLVED: 'order:decision_resolved',

  /** Auth security event: current sessions were revoked and client must re-auth. */
  AUTH_SESSION_REVOKED: 'auth:session_revoked',

  /** Order lifecycle status update (canonical). Emitted by order-state-machine. */
  ORDER_STATUS_UPDATE: 'order:status:update',
  /** Driver geo update (lat/lng) for an in-progress delivery. */
  DRIVER_LOCATION_UPDATE: 'driver:location:update',
  /** Stripe payment captured/confirmed for an order. */
  PAYMENT_CONFIRMED: 'payment:confirmed'
} as const;

export type SocketEventName = (typeof SOCKET_EVENTS)[keyof typeof SOCKET_EVENTS];

export const SOCKET_ROOM_PREFIX = {
  ORDER: 'order:'
} as const;

export const orderRoomName = (orderId: string) => `${SOCKET_ROOM_PREFIX.ORDER}${orderId}`;
